import React, { useState, useRef } from 'react'
import classNames from 'classnames'
import { DEFAULT_ACCENT } from '../../utils/constants'
import './style.scss'

const BadgeInput = ({ label, color = DEFAULT_ACCENT, onChange, isValid, values, errorMessage, helperText, showCount, hasError }) => {
  const [badges, setBadges] = useState(values || [])
  const [fieldValue, setFieldValue] = useState('')
  const [errorText, setErrorText] = useState('')
  const fieldRef = useRef(null)

  const onWrapperClick = () => {
    fieldRef.current.focus()
  }

  const onItemClick = (e, badge) => {
    e.stopPropagation()
    e.preventDefault()
    const updateBadges = badges.filter(item => item !== badge)
    onChange && onChange(updateBadges)
    setBadges(updateBadges)
  }

  const onFieldChange = (e) => {
    setErrorText('')
    hasError && hasError(false)
    setFieldValue(e.target.value)
  }

  const onFieldConfirm = (e) => {
    if (e.key === 'Enter' && !badges.includes(fieldValue)) {
      e.stopPropagation()
      e.preventDefault()
      addBadge()
    }
  }

  const addBadge = () => {
    if (fieldValue) {
      if (isValid && !isValid(fieldValue)) {
        setErrorText(errorMessage)
        hasError && hasError(true)
      } else {
        const updateBadges = [...badges, fieldValue]
        onChange && onChange(updateBadges)
        setBadges(updateBadges)
        setFieldValue('')
        hasError && hasError(false)
      }
    }
  }

  return (
    <div className='viso-badge-input'>
      <div className='viso-badge-input__wrapper'>
        <div className='viso-badge-input__label'>{label}</div>
        <div
          className={classNames('viso-badge-input__frame', errorText && 'viso-border-danger')}
          onClick={onWrapperClick}
        >
          {values.length > 0 && values.map((badge, index) =>
            <div className={classNames('viso-badge-input__item', `viso-bg-${color}-10 viso-text-${color}`)} key={index} onClick={(e) => onItemClick(e, badge)}>{badge}</div>
          )}
          <input ref={fieldRef} value={fieldValue} type='text' className='viso-badge-input__field' onChange={onFieldChange} onBlur={addBadge} onKeyDown={onFieldConfirm} />
        </div>
      </div>
      <div className={classNames('viso-badge-input__helper', errorText && 'viso-text-danger')}>
        {errorText ? errorText :
          `${showCount ? badges.length : ''} ${helperText ? helperText : ''}${showCount ? '(s)' : ''}`
        }
      </div>
    </div>
  )
}

export default BadgeInput